module.exports = __webpack_public_path__ + "faa82ee2fb95fae5a85f8140e1560494.pdf";